import { Component, OnInit } from '@angular/core';
import { RoleId } from '@sb-shared/enums/role.enum';
import { User } from '@sb-shared/models/user';
import { OrganisationService } from '@sb-shared/services/organisation.service';
import { UserService } from '@sb-shared/services/user.service';
import { ProfileDataService } from '../../services/profile-data.service';

@Component({
    selector: 'sb-profile-linked',
    templateUrl: './profile-linked.component.html',
    styleUrls: ['./profile-linked.component.scss'],
    standalone: false
})
export class ProfileLinkedComponent implements OnInit {

  selectedPerson: User;
  isOrganisationAdmin: boolean;
  isPopup: boolean;
  organisationTypeId: number;

  constructor(
    private profileData: ProfileDataService,
    private orgSvc: OrganisationService,
    private userSvc: UserService
  ) { }

  ngOnInit(): void {
    this.isPopup = this.profileData.isProfilePopup();

    this.profileData.getUserInContext().subscribe(user => {
      this.selectedPerson = user;
    });

    this.orgSvc.getCurrentOrganisation().subscribe(org => {
      this.organisationTypeId = org.organisationTypeId;
    });

    this.userSvc.getCurrentUser().subscribe(user => {
      this.isOrganisationAdmin = user.userRoleIds.includes(RoleId.Admin);
    });
  }
}
